module.exports = __webpack_public_path__ + "img/page4_store_bag.eca45e63.png";